// extracted by mini-css-extract-plugin
export default {"suggestion-item":"suggestion-item--mLxfuEGm0g","suggestionItem":"suggestion-item--mLxfuEGm0g","suggestion":"suggestion--I9nVsxwZQ-","icon":"icon---IDJICds9O"};